import { useRef, useState } from "react";
import Select from "react-select";
import { Button, Col, Form, Row } from "react-bootstrap";


function AddVehicle({ validateUserData, InputFileFieldRender, handleImageClick, handleFileChange, submitData, errors, setErrors, previews, vehicleData, setVehicleData, type, districts, stages, getStages }) {
	const carBrandsInUganda = ["Toyota", "Nissan", "Honda", "Suzuki", "Subaru", "Mitsubishi", "Volkswagen", "BMW", "Mercedes-Benz", "Peugeot", "Audi", "Ford", "Chevrolet", "Jeep", "Hyundai", "Kia", "Isuzu", "Chery", "BYD", "Great Wall Motors", "Porsche", "Land Rover", "Lexus", "Other"];
	const bikeBrands = ["Bajaj", "TVS", "Haojue", "Hero", "Honda", "Suzuki", "Kawasaki", "Kibo", "Zembo", "Spiro", "GoGo", "Other"]
	const bikeColors = ["White", "Black", "Gray", "Silver", "Blue", "Red", "Green", "Yellow", "Orange", "Purple", "Brown", "Gold", "Pink", "Other"]
	const vehicleSubtypes = [
		{ label: "Electric Boda", value: "Electric Boda", type: "boda" },
		{ label: "Union Boda", value: "Union Boda", type: "boda" },
		{ label: "Union Car", value: "Union Car", type: "car" },
		{ label: "Union Car Large", value: "Union Car Large", type: "car" },
	]
	const plateExpRef = useRef();
	const insuranceExpRef = useRef();
	const otherStage = { label: "Other", value: "other" }

	function handleDistrictChange(value) {
		getStages(value.value);
		setVehicleData({ ...vehicleData, district: value });
		setErrors(prev => ({ ...prev, district: null }));
	}

	const handleSubmit = () => {
		const isUserDataValid = validateUserData();

		if (isUserDataValid) {
			submitData();
		}
	};

	return (
		<Row className="justify-content-end">
			<Col md={6} className="mb-3">
				<Form.Group>
					<Form.Label>Vehicle Subtype</Form.Label>
					<Select
						options={vehicleSubtypes.filter(t => t.type === type)}
						placeholder="Select Vehicle Subtype"
						onChange={(value) => {
							setVehicleData({ ...vehicleData, vehicle_sub_type: value.value });
							setErrors(prev => ({ ...prev, vehicle_sub_type: null }));
						}}
					/>
					{errors.vehicle_sub_type && <Form.Control.Feedback className="d-block" type="invalid">{errors.vehicle_sub_type}</Form.Control.Feedback>}
				</Form.Group>
			</Col>
			<Col md={6} className="mb-3">
				<Form.Group>
					<Form.Label>Vehicle Brand</Form.Label>
					<Select
						options={type === "car" ? carBrandsInUganda.map(brand => ({ value: brand, label: brand })) : bikeBrands.map(brand => ({ value: brand, label: brand }))}
						placeholder="Select Vehicle Brand"
						onChange={(value) => {
							setVehicleData({ ...vehicleData, vehicle_brand: value.value });
							setErrors(prev => ({ ...prev, vehicle_brand: null }));
						}}
					/>
					{errors.vehicle_brand && <Form.Control.Feedback className="d-block" type="invalid">{errors.vehicle_brand}</Form.Control.Feedback>}
				</Form.Group>
			</Col>
			<Col md={6} className="mb-3">
				<Form.Group>
					<Form.Label>Vehicle Model</Form.Label>
					<Form.Control
						type="text"
						placeholder="Enter Vehicle Model"
						maxLength={6}
						onChange={(e) => {
							setVehicleData({ ...vehicleData, vehicle_model: e.target.value });
							setErrors(prev => ({ ...prev, vehicle_model: null }));
						}}
					/>
					{errors.vehicle_model && <Form.Control.Feedback className="d-block" type="invalid">{errors.vehicle_model}</Form.Control.Feedback>}
				</Form.Group>
			</Col>
			<Col md={6} className="mb-3">
				<Form.Group>
					<Form.Label>Vehicle Color</Form.Label>
					<Select options={bikeColors.map(c => ({ label: c, value: c }))} placeholder="Select Vehicle Color"
						onChange={(value) => {
							setVehicleData({ ...vehicleData, vehicle_color: value.value });
							setErrors(prev => ({ ...prev, vehicle_color: null }));
						}}
					/>
					{errors.vehicle_color && <Form.Control.Feedback className="d-block" type="invalid">{errors.vehicle_color}</Form.Control.Feedback>}
				</Form.Group>
			</Col>
			<Col md={vehicleData.stage === "other" ? 3 : 6} className="mb-3">
				<Form.Group>
					<Form.Label>District</Form.Label>
					<Select value={vehicleData.district} options={districts.length ? districts.map(d => ({ label: d.name, value: d.id })) : []} placeholder="Select Vehicle District" onChange={handleDistrictChange}
					/>
					{errors.district && <Form.Control.Feedback className="d-block" type="invalid">{errors.district}</Form.Control.Feedback>}
				</Form.Group>
			</Col>
			<Col md={vehicleData.stage === "other" ? 3 : 6} className="mb-3">
				<Form.Group>
					<Form.Label>Stage (Optional)</Form.Label>
					<Select options={stages.length ? [otherStage, ...stages.map(d => ({ label: d.name, value: d.id }))].sort((a, b) => a - b) : [otherStage]} placeholder="Select Vehicle Stage"
						onChange={(value) => {
							setVehicleData({ ...vehicleData, stage: value.value });
							setErrors(prev => ({ ...prev, stage: null }));
						}}
					/>
					{errors.stage && <Form.Control.Feedback className="d-block" type="invalid">{errors.stage}</Form.Control.Feedback>}
				</Form.Group>
			</Col>
			{
				vehicleData.stage === "other" &&
				<Col md={6} className="mb-3">
					<Form.Group className="mb-3" controlId="exampleForm.stageName">
						<Form.Label>Stage Name</Form.Label>
						<Form.Control
							value={vehicleData.stage_name}
							name="stage_name"
							placeholder="Enter stage name"
							maxLength={50}
							onChange={(event) => {
								setVehicleData({ ...vehicleData, stage_name: event.target.value });

							}}
						/>
						{errors.stage_name && <Form.Control.Feedback className="d-block" type="invalid">{errors.stage_name}</Form.Control.Feedback>}
					</Form.Group>
				</Col>
			}
			<Col md={6} className="mb-3">
				<Form.Group>
					<Form.Label>Vehicle Number Plate</Form.Label>
					<div className="document-upload-area">
						<h5>Upload Number Plate Photo</h5>
						<Form.Control type="file" data-tab="vehicle" onChange={(e) => handleFileChange(e, "number_plate")} ref={plateExpRef} accept="image/*" className="d-none" />
						{
							previews.number_plate ?
								<img
									src={previews.number_plate}
									className="document-inner"
									onClick={() => handleImageClick(plateExpRef)}
									alt="Number plate preview"
									style={{ cursor: 'pointer', maxWidth: '100%', height: 'auto' }}
								/>
								:
								<InputFileFieldRender ref={plateExpRef} />
						}
						{errors.number_plate && <Form.Control.Feedback className="d-block" type="invalid">{errors.number_plate}</Form.Control.Feedback>}
					</div>
				</Form.Group>
			</Col>
			<Col md={6} className="mb-3">
				<Form.Group>
					<Form.Label>Vehicle Insurance</Form.Label>
					<div className="document-upload-area">
						<h5>Upload Third-Party Insurance Certificate (Optional)</h5>
						<Form.Control type="file" data-tab="vehicle" onChange={(e) => handleFileChange(e, "insurance")} ref={insuranceExpRef} accept="image/*" className="d-none" />
						{
							previews.insurance ?
								<img
									src={previews.insurance}
									className="document-inner"
									onClick={() => handleImageClick(insuranceExpRef)}
									alt="Insurance document preview"
									style={{ cursor: 'pointer', maxWidth: '100%', height: '100px' }}
								/>
								:
								<InputFileFieldRender ref={insuranceExpRef} />
						}
						{errors.insurance && <Form.Control.Feedback className="d-block" type="invalid">{errors.insurance}</Form.Control.Feedback>}
					</div>
				</Form.Group>
			</Col>
			<Col md={6} className="mb-3">
				<Form.Group>
					<Form.Label>Number Plate Number</Form.Label>
					<Form.Control
						type="text"
						maxLength={50}
						placeholder="Enter Vehicle Number Plate"
						onChange={(e) => {
							setVehicleData({ ...vehicleData, vehicle_number_plate: e.target.value });
							setErrors(prev => ({ ...prev, vehicle_number_plate: null }));
						}}
					/>
					{errors.vehicle_number_plate && <Form.Control.Feedback className="d-block" type="invalid">{errors.vehicle_number_plate}</Form.Control.Feedback>}
				</Form.Group>
			</Col>
			<Col md={6} className="mb-3">
				<Form.Group>
					<Form.Label>Insurance Number (Optional)</Form.Label>
					<Form.Control
						type="text"
						maxLength={50}
						placeholder="Enter Third-Party Insurance Number"
						onChange={(e) => {
							setVehicleData({ ...vehicleData, insurance_number: e.target.value });
							setErrors(prev => ({ ...prev, insurance_number: null }));
						}}
					/>
					{errors.insurance_number && <Form.Control.Feedback className="d-block" type="invalid">{errors.insurance_number}</Form.Control.Feedback>}
				</Form.Group>
			</Col>
			{/* <Col md={6} className="mb-3">
				<Form.Group>
					<Form.Label>Number Plate Expiry Date</Form.Label>
					<Form.Control type="date" id="id_npn_expiry" min={new Date().toISOString().split('T')[0]}
						onChange={(e) => {
							setVehicleData({ ...vehicleData, number_plate_expiry: e.target.value });
							setErrors(prev => ({ ...prev, number_plate_expiry: null }));
						}}
					/>
					{errors.number_plate_expiry && <Form.Control.Feedback className="d-block" type="invalid">{errors.number_plate_expiry}</Form.Control.Feedback>}
				</Form.Group>
			</Col> */}
			<Col md={6} className="mb-3">
				<Form.Group>
					<Form.Label>Insurance Expiry Date (Optional)</Form.Label>
					<Form.Control type="date" id="id_ins_expiry" min={new Date().toISOString().split('T')[0]}
						onChange={(e) => {
							setVehicleData({ ...vehicleData, insurance_expiry: e.target.value });
							setErrors(prev => ({ ...prev, insurance_expiry: null }));
						}}
					/>
					{errors.insurance_expiry && <Form.Control.Feedback className="d-block" type="invalid">{errors.insurance_expiry}</Form.Control.Feedback>}
				</Form.Group>
			</Col>
			<Col md={6} className="mb-3 float-right mt-3">
				<Button
					className="primary-btns me-0"
					onClick={handleSubmit}
				>
					Submit
				</Button>
			</Col>
		</Row>
	)
}

export default AddVehicle;